export default "__VITE_ASSET__Clrhh_NY__"